import { Component, OnInit } from '@angular/core';
import {Observable} from 'rxjs/Rx';
import { NavController, ModalController } from 'ionic-angular';
import { ProjectDataProvider } from '../../providers/project-data-provider';

import { ProjectPage } from '../project/project';

@Component({
  selector: 'page-home',
  templateUrl: 'home.html',
  providers : [ ProjectDataProvider ]
})
export class HomePage implements OnInit {
  projects : any[]; // Todo: IProject
  timeNow;

  constructor(public navCtrl: NavController, public modalCtrl: ModalController, public prjDataProv : ProjectDataProvider) {
  
  }

  ngOnInit(){
    this.projects = this.prjDataProv.findAll();
    this.timeToString(0);

    let timer = Observable.timer(0,5*1000);
    timer.subscribe(t => this.timeToString(t));
  }

  timeToString(ticks) {
    var now = new Date();
    this.timeNow = now.toISOString().substring(11,16); // = now.getHours() + ":" + now.getMinutes();
  }

  openModal() {
      let modal = this.modalCtrl.create(ProjectPage, { projectObj : {}});
      modal.present();
  }

  openModalById(projectNumber : string) {
      // console.log(projectNumber);
      var proj = this.prjDataProv.findByProjectNumber(projectNumber)[0];
      // console.log(proj);
      let modal = this.modalCtrl.create(ProjectPage, { projectObj : proj});
      modal.present();
  }

   getItems(ev) {
    // Reset items back to all of the items
    this.projects = this.prjDataProv.findAll();

    // set val to the value of the ev target
    var val = ev.target.value;

    // if the value is an empty string don't filter the items
    if (val && val.trim() != '') {
      this.projects = this.prjDataProv.findBySearchTerm(val);
    }
   }

}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts